import { get } from "lodash";
import React from "react";
import { ReferenceInput, SelectInput, useTranslate } from "react-admin";

const StatusInput = (props) => {
	const translate = useTranslate();
	return (
		<ReferenceInput
			{...props}
			reference="user-payment-statuses"
			allowEmpty
			emptyText="resources.user_payment_statuses.code.all"
			sort={{ field: "id", direction: "asc" }}
		>
			<SelectInput
				optionText={(record) =>
					translate(
						`resources.user_payment_statuses.code.${get(record, "code")}`
					)
				}
			/>
		</ReferenceInput>
	);
};

export default StatusInput;
